import React, { createContext, useContext, useReducer } from "react";
import Constants from "../Constants";

import {
  getCurrentLocale,
  setCurrentLocale,
  getCurrentLanguageCode,
  getCurrentCountryCode,
  isRtl,
  getFallbackLanguage,
  setFallbackLanguage,
  getLanguages,
  setLanguages,
  getTranslations,
  setTranslations,
  t,
} from "./Translate";

// Configuration
const { language, fallBacklanguage, languages } = {
  language: Constants.AE.enlocaleCode,
  fallBacklanguage: Constants.AE.enlocaleCode,
  languages: [
    Constants.AE.arlocaleCode,
    Constants.OM.arlocaleCode,
    Constants.QA.arlocaleCode,
    Constants.EG.arlocaleCode,
    Constants.OM.enlocaleCode,
    Constants.AE.enlocaleCode,
    Constants.QA.enlocaleCode,
    Constants.EG.enlocaleCode,
  ],
};

// Init language properties

// setCurrentLocale(language);
setFallbackLanguage(fallBacklanguage);
setLanguages(languages);

// Contexts
const TranslateContext = createContext();
const TranslateStateContext = createContext();
const TranslateDispatchContext = createContext();

// Reducers

function translateReducer(state, action) {
  switch (action.type) {
    case "CHANGE_LANGUAGE": {
      setCurrentLocale(action.language);
      return { ...state, language: action.language };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// Initial state
const initialState = {
  language,
};

export const TranslateProvider = (props) => {
  const value = {
    getCurrentLocale: props.getCurrentLocale || getCurrentLocale,
    setCurrentLocale: props.setCurrentLocale || setCurrentLocale,
    getCurrentLanguageCode:
      props.getCurrentLanguageCode || getCurrentLanguageCode,
    getCurrentCountryCode: props.getCurrentCountryCode || getCurrentCountryCode,
    isRtl: props.isRtl || isRtl,
    getFallbackLanguage: props.getFallbackLanguage || getFallbackLanguage,
    setFallbackLanguage: props.setFallbackLanguage || setFallbackLanguage,
    getLanguages: props.getLanguages || getLanguages,
    setLanguages: props.setLanguages || setLanguages,
    getTranslations: props.getTranslations || getTranslations,
    setTranslations: props.setTranslations || setTranslations,
    t: props.t || t,
  };
  const [state, dispatch] = useReducer(translateReducer, initialState);

  return (
    <TranslateContext.Provider value={value}>
      <TranslateStateContext.Provider value={state}>
        <TranslateDispatchContext.Provider value={dispatch}>
          {props.children}
        </TranslateDispatchContext.Provider>
      </TranslateStateContext.Provider>
    </TranslateContext.Provider>
  );
};

export const useTranslate = () => {
  // You can use the function of provider
  const context = useContext(TranslateContext);
  if (context === undefined) {
    throw new Error("useTranslate must be used within a TranslateProvider");
  }
  return context;
};

export const useTranslateState = () => {
  const context = useContext(TranslateStateContext);
  if (context === undefined) {
    throw new Error(
      "useTranslateState must be used within a TranslateProvider"
    );
  }
  return context;
};

export const useTranslateDispatch = () => {
  const context = useContext(TranslateDispatchContext);
  if (context === undefined) {
    throw new Error(
      "useTranslateDispatch must be used within a TranslateProvider"
    );
  }
  return context;
};
